var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#FFFC9F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_721_12700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99974 9.29098C8.71233 9.29098 9.29 8.71331 9.29 8.00071C9.29 7.28812 8.71233 6.71045 7.99974 6.71045C7.28714 6.71045 6.70947 7.28812 6.70947 8.00071C6.70947 8.71331 7.28714 9.29098 7.99974 9.29098Z",
    fill: "#626017"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0615 7.64341C11.0697 6.44492 9.56839 5.29126 7.99958 5.29126C6.43045 5.29126 4.9288 6.44572 3.93766 7.64341C3.76622 7.8505 3.76622 8.15113 3.93766 8.35822C4.18685 8.65933 4.70924 9.24059 5.40695 9.74847C7.16411 11.0276 8.83117 11.0305 10.5922 9.74847C11.2899 9.24059 11.8123 8.65933 12.0615 8.35822C12.2324 8.15153 12.2333 7.85117 12.0615 7.64341ZM7.99958 6.19444C8.99566 6.19444 9.80594 7.00473 9.80594 8.00081C9.80594 8.9969 8.99566 9.80718 7.99958 9.80718C7.00349 9.80718 6.19321 8.9969 6.19321 8.00081C6.19321 7.00473 7.00349 6.19444 7.99958 6.19444Z",
    fill: "#626017"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_721_12700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.38095,
    height: 8.38095,
    fill: "white",
    transform: "translate(3.80933 3.80957)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionIcon);
export default __webpack_public_path__ + "static/media/ActionIcon.6ec5e18e5daeaafaaf654c3596651b05.svg";
export { ForwardRef as ReactComponent };